<template>
    <div ref="chartRef" class="disease-chart" :style="{ height }"></div>
</template>

<script>
export default {
    name: 'DiseaseChart',
    props: {
        option: {
            type: Object,
            default: null,
        },
        height: {
            type: String,
            default: '320px',
        },
    },
    data() {
        return {
            chart: null,
        };
    },
    watch: {
        option: {
            deep: true,
            handler() {
                this.renderChart();
            },
        },
    },
    mounted() {
        this.initChart();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },
    methods: {
        initChart() {
            if (!this.$refs.chartRef) return;
            this.chart = this.$echarts.init(this.$refs.chartRef);
            this.renderChart();
        },
        renderChart() {
            if (this.chart && this.option) {
                this.chart.setOption(this.option, true);
            }
        },
        handleResize() {
            if (this.chart) {
                this.chart.resize();
            }
        },
    },
};
</script>

<style lang="less" scoped>
.disease-chart {
    width: 100%;
}
</style>
